import { Injectable } from '@angular/core';
import { LoginResponseDTO } from './bsapi.service';

const LOCALSTORAGE_KEY_LOGIN_DETAILS = 'BS_LOGIN_DETAILS';
const LOCALSTORAGE_KEY_ENVIRONMENT_DETAILS = 'BS_ENVIRONMENT_DETAILS';
const SESSION_STORAGE_KEY_SESSION_TOKEN = 'BS_SESSION_TOKEN';

@Injectable({
  providedIn: 'root',
})
export class BsportalstorageService {
  clearSession() {
    sessionStorage.removeItem(LOCALSTORAGE_KEY_LOGIN_DETAILS);
    sessionStorage.removeItem(LOCALSTORAGE_KEY_ENVIRONMENT_DETAILS);
    sessionStorage.clear();
  }

  putLoginDetails(loginDetails: LoginResponseDTO) {
    sessionStorage.setItem(
      LOCALSTORAGE_KEY_LOGIN_DETAILS,
      JSON.stringify(loginDetails),
    );
  }

  getLoginDetails() {
    return this.localStorageAsTypeOrNull<LoginResponseDTO>(
      LOCALSTORAGE_KEY_LOGIN_DETAILS,
    );
  }

  putSessionToken(sessionToken: string) {
    localStorage.setItem(SESSION_STORAGE_KEY_SESSION_TOKEN, sessionToken);
  }

  // putEnvironmentDetails(environmentDetail: EnvironmentDetailDTO) {
  //   sessionStorage.setItem(
  //     LOCALSTORAGE_KEY_ENVIRONMENT_DETAILS,
  //     JSON.stringify(environmentDetail),
  //   );
  // }

  // getEnvironmentDetails() {
  //   return this.localStorageAsTypeOrNull<EnvironmentDetailDTO>(
  //     LOCALSTORAGE_KEY_LOGIN_DETAILS,
  //   );
  // }

  private localStorageAsTypeOrNull<T>(key: string) {
    const item = sessionStorage.getItem(key);
    if (!item) {
      return null;
    }

    return JSON.parse(item) as T;
  }

  testUserDetail = `
  {"sessionId":"5a006ff044b5b7bbf19d8816a36b0d85","loginType":"CUSTOMER","userInfo":{"userId":"34056924-ee2a-4213-bbc0-8d3288d63249","userRole":"ADMIN","login":"18184","firstName":"Emile","lastName":"Wolmarans","phone":"","email":"emile@revos.co.za,riaanv@revos.co.za,charlene@revos.co.za,riaan.vos@gmail.com"},"customerInfo":{"i_customer":18184,"name":"Revos Hardware (Pty) Ltd","companyName":"Revos Hardware (Pty) Ltd","currency":"ZAR","openingBalance":0,"balance":45.58,"permCreditLimit":127000,"addressLine1":"10 Eastern Service Road","addressLine2":"","city":"Sandton","state":"Gauteng","postalCode":"2090","phone":"","email":"emile@revos.co.za,riaanv@revos.co.za,charlene@revos.co.za,riaan.vos@gmail.com","balanceControlType":"postpaid","status":null,"billStatus":"operational","externalRef1Enabled":false,"externalRef1Label":null,"externalRef2Enabled":false,"externalRef2Label":null,"customerType":"PBX"}}
  `;
}
